import * as React from 'react'
import { Close, Search } from '@mui/icons-material'
import Modal from 'react-modal'
import { useDispatch, useSelector } from 'react-redux'
import { Field, FieldArray, formValueSelector } from 'redux-form'
import { IconButton } from '@mui/material'
import { referenceError, referenceErrorRemove, searchReferences } from '../../actions/referencesActions'
import { REFERENCE_TYPES } from '../../config/config'
import { loadingState } from '../../utils/loadingState'
import { containsByReferenceId, getTitleByValue, or } from '../../utils/utils'
import OpenClose from '../general/OpenClose'
import { COLOR_BLACK, COLOR_GREY, COLOR_LIGHT_TEXT } from '../../config/colors'
import TextButton from '../general/TextButton'
import { CustomTextField } from '../general/CustomTextField'

const ReferencesSearch = ({ name, formType, onSelect }) => {
  const items = useSelector((state) => state.references.searchItems)
  const references = useSelector((state) => or(formValueSelector(formType)(state, name), []))
  const searchState = useSelector((state) => state.references.searchState)
  const dispatch = useDispatch()
  const search = (query) => dispatch(searchReferences(query))
  return (
    <div style={{ width: '100%' }}>
      <div className="field-with-icon">
        <CustomTextField
          id="reference-search-input"
          width="full"
          light="true"
          label="Search"
          hideLabel={true}
          type="text"
          onChange={(_, query) => search(query)}
        />
        <Search className="search-icon" style={{ color: COLOR_BLACK }} />
      </div>
      {searchState === loadingState.IDLE ? null : searchState === loadingState.LOADING ? (
        <span>Searching...</span>
      ) : items.length === 0 ? (
        <span>No results</span>
      ) : (
        <div className="scrollable">
          <table className="non-fixed" cellSpacing={0}>
            <tbody>
              <tr>
                <th>Author</th>
                <th>Year</th>
                <th>Title</th>
                <th>Reference type</th>
                <th />
              </tr>
              {items.map((item, i) => (
                <OpenClose key={i}>
                  {({ isOpen, open, close }) => (
                    <React.Fragment>
                      <tr
                        key={i}
                        className={(i + 1) % 2 === 0 ? 'odd edit-toggle' : 'even edit-toggle'}
                        onClick={isOpen ? close : open}
                      >
                        <td>{item.author}</td>
                        <td>{item.year}</td>
                        <td>{item.title}</td>
                        <td>{item.type ? getTitleByValue(item.type, REFERENCE_TYPES) : ''}</td>
                        <td style={{ width: '200px' }} />
                      </tr>
                      {isOpen ? (
                        <tr className={(i + 1) % 2 === 0 ? 'odd edit-open' : 'even edit-open'}>
                          <td colSpan={4}>
                            <div className=" flex-box-centered ref-comments">
                              <div className="field-label" style={{ width: '90px' }}>
                                Page:
                              </div>
                              <Field
                                id={'name_temp' + '[' + i + '].page-input'}
                                name={'name_temp' + '[' + i + '].page'}
                                width="short"
                                light={true}
                                component={CustomTextField}
                                label="Page:"
                                hideLabel={true}
                                onChange={(e) => {
                                  item.page = e.target.value
                                }}
                              />
                              <div className="field-label" style={{ width: '140px', margin: '0 32px 0 55px' }}>
                                Catalogue number:
                              </div>
                              <Field
                                id={'name_temp' + '[' + i + '].catalogue-input'}
                                name={'name_temp' + '[' + i + '].catalogue'}
                                width="short"
                                light={true}
                                component={CustomTextField}
                                label="Catalogue number:"
                                hideLabel={true}
                                onChange={(e) => {
                                  item.catalogue = e.target.value
                                }}
                              />
                            </div>
                            <div className=" flex-box-centered ref-comments">
                              <div className="field-label" style={{ width: '90px' }}>
                                Comments:
                              </div>
                              <Field
                                id={'name_temp' + '[' + i + '].comment-input'}
                                name={'name_temp' + '[' + i + '].comment'}
                                className="flex-full"
                                component={CustomTextField}
                                light={true}
                                label="Comments:"
                                hideLabel={true}
                                onChange={(e) => {
                                  item.comment = e.target.value
                                }}
                              />
                            </div>
                          </td>
                          <td style={{ width: '200px', textAlign: 'center' }}>
                            <TextButton
                              disabled={containsByReferenceId(references, item.id)}
                              color="primary"
                              onClick={() => {
                                onSelect(item)
                                close()
                              }}
                              type="button"
                              label="Add Reference"
                            />
                          </td>
                        </tr>
                      ) : null}
                    </React.Fragment>
                  )}
                </OpenClose>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

const renderHeader = () => (
  <tr>
    <th>Author</th>
    <th>Year</th>
    <th>Title</th>
    <th>Reference type</th>
    <th>Pages</th>
    <th />
  </tr>
)

const ReferenceListItem = ({ name, onRemove, item, index }) => (
  <OpenClose defaultValue={item ? item.page : undefined}>
    {({ isOpen, open, close }) => (
      <React.Fragment>
        <tr key={index} className={isOpen ? 'open-row' : (index + 1) % 2 === 0 ? 'odd' : 'even'}>
          <td>{item.author}</td>
          <td>{item.year}</td>
          <td>{item.title}</td>
          <td>{item.type ? getTitleByValue(item.type, REFERENCE_TYPES) : ''}</td>
          <td>{item.page ? item.page : ''}</td>
          <td>
            <div className="flex-box-centered">
              {isOpen ? (
                <TextButton
                  color="primary"
                  onClick={() => {
                    close()
                  }}
                  type="button"
                  label="Save"
                />
              ) : (
                <TextButton color="primary" onClick={open} type="button" label="Edit" />
              )}
              <IconButton
                className="repeater-remove"
                onClick={() => {
                  onRemove()
                }}
                size="large">
                <Close style={{ color: COLOR_LIGHT_TEXT }} />
              </IconButton>
            </div>
          </td>
        </tr>
        {item.comment ? (
          <tr className={isOpen ? 'open-row' : (index + 1) % 2 === 0 ? 'odd' : 'even'}>
            <td colSpan={6} className="tr-comment">
              {item.comment}
            </td>
          </tr>
        ) : null}
        {isOpen ? (
          <tr className={isOpen ? 'open-row' : ''}>
            <td colSpan={6}>
              <div>
                <div className=" flex-box-centered ref-comments">
                  <div className="field-label" style={{ width: '140px' }}>
                    Page:
                  </div>
                  <Field
                    id={name + '.page-input'}
                    name={name + '.page'}
                    width="short"
                    light={true}
                    component={CustomTextField}
                    label="Page:"
                    hideLabel={true}
                  />
                  <div className="field-label" style={{ width: '140px', margin: '0 16px' }}>
                    Catalogue number:
                  </div>
                  <Field
                    id={name + '.catalogue-input'}
                    name={name + '.catalogue'}
                    width="short"
                    light={true}
                    component={CustomTextField}
                    label="Catalogue number:"
                    hideLabel={true}
                  />
                </div>
                <div className=" flex-box-centered ref-comments">
                  <div className="field-label" style={{ width: '140px' }}>
                    Comments:
                  </div>
                  <Field
                    id={name + '.comment-input'}
                    name={name + '.comment'}
                    className="flex-full"
                    component={CustomTextField}
                    light={true}
                    label="Comments:"
                    hideLabel={true}
                  />
                </div>
              </div>
            </td>
          </tr>
        ) : null}
      </React.Fragment>
    )}
  </OpenClose>
)

const ReferencesList = ({ fields, formType }) => {
  const dispatch = useDispatch()
  const showError = (value) => dispatch(referenceError(value))
  const removeError = (value) => dispatch(referenceErrorRemove(value))
  const colorAccent = useSelector((state) => state.auth.colorAccent)
  return (
    <OpenClose>
      {({ isOpen, open, close }) => (
        <div className="ref-tabs">
          <span
            className={`${!isOpen ? 'tab active' : 'tab'} modal-header`}
            style={{ borderBottomColor: !isOpen ? colorAccent : COLOR_GREY }}
            onClick={() => close()}
          >
            Add References
          </span>
          {!isOpen && (
            <ReferencesSearch
              name={fields.name}
              formType={formType}
              onSelect={(x) => {
                fields.push({ ...x, reference_id: x.id })
              }}
            />
          )}
          <span
            href="#"
            className={`${isOpen ? 'tab active' : 'tab'} modal-header`}
            style={{ borderBottomColor: isOpen ? colorAccent : COLOR_GREY }}
            onClick={() => open()}
          >
            Existing References
          </span>
          {isOpen && (
            <table className="non-fixed existing-refs" cellSpacing={0}>
              <tbody>
                {renderHeader()}
                {fields.map((name, index) => (
                  <ReferenceListItem
                    key={index}
                    index={index}
                    name={name}
                    showError={showError}
                    removeError={removeError}
                    onRemove={() => fields.remove(index)}
                    item={fields.get(index)}
                  />
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </OpenClose>
  )
}

export const ReferencesForm = ({ name, formType, close }) => (
  <div>
    <FieldArray name={name} formType={formType} component={ReferencesList} />
    <div className="right-controls">
      <TextButton
        color="primary"
        onClick={() => {
          close()
        }}
        type="button"
        label="Done"
      />
    </div>
  </div>
)

export const ReferenceField = (props) => {
  const references = useSelector((state) => or(formValueSelector(props.formType)(state, props.name), []))
  const colorAccent = useSelector((state) => state.auth.colorAccent)
  return (
    <OpenClose>
      {({ isOpen, open, close }) => (
        <div className="reference-holder">
          {references.length !== 0 && (
            <div className="reference-exerpt">
              {references.map((reference) =>
                reference.author
                  ? reference.author.slice(0, reference.author.indexOf(', ')) +
                    ' (' +
                    reference.year +
                    ', ' +
                    reference.catalogue +
                    ') '
                  : null
              )}
            </div>
          )}
          <div className="reference-link" onClick={open} type="button" style={{ color: colorAccent }}>
            {references.length === 0 ? 'Add References' : 'Edit References'}
          </div>
          <Modal
            isOpen={isOpen}
            onRequestClose={close}
            className={{
              base: 'modal',
              afterOpen: 'modal-open reference-modal',
              beforeClose: 'modal-close',
            }}
            overlayClassName={{
              base: 'modal-overlay',
              afterOpen: 'modal-overlay-open',
              beforeClose: 'modal-overlay-close',
            }}
          >
            <ReferencesForm {...props} close={close} />
          </Modal>
        </div>
      )}
    </OpenClose>
  )
}
